import type { SubTopicStat } from '../game/RoundState';
import type { SubTopic } from '../data/cards';
import { SUB_TOPIC_ORDER, subTopicLabel } from './subtopicLabels';

export class SummaryPanel {
  private readonly root = this.getElement('#summary-panel');
  private readonly scoreEl = this.getElement('#summary-score');
  private readonly tierEl = this.getElement('#summary-tier');
  private readonly outroEl = this.getElement('#summary-outro');
  private readonly subtopicsEl = this.getElement('#summary-subtopics');
  private readonly retryWrongButton = this.getElement<HTMLButtonElement>('#summary-retry-wrong');

  constructor(onRestart: () => void, onRetryWrong: () => void) {
    this.getElement('#summary-restart').addEventListener('click', onRestart);
    this.retryWrongButton.addEventListener('click', onRetryWrong);
  }

  show(
    correctCount: number,
    total: number,
    tierLabel: string,
    outroText: string,
    subTopicStats: Record<SubTopic, SubTopicStat>,
    wrongCount: number,
  ): void {
    this.scoreEl.textContent = `${correctCount} / ${total}개 정답`;
    this.tierEl.textContent = `마을 상태: ${tierLabel}`;
    this.outroEl.textContent = outroText;

    this.subtopicsEl.innerHTML = '';
    for (const topic of SUB_TOPIC_ORDER) {
      const stat = subTopicStats[topic];
      if (stat.total === 0) continue;
      const item = document.createElement('li');
      item.textContent = `${subTopicLabel(topic)}: ${stat.correct}/${stat.total}`;
      this.subtopicsEl.append(item);
    }

    if (wrongCount > 0) {
      this.retryWrongButton.textContent = `틀린 카드 다시 풀기 (${wrongCount}장)`;
      this.retryWrongButton.hidden = false;
    } else {
      this.retryWrongButton.hidden = true;
    }

    this.root.hidden = false;
  }

  hide(): void {
    this.root.hidden = true;
  }

  private getElement<T extends HTMLElement = HTMLElement>(selector: string): T {
    const element = document.querySelector<T>(selector);
    if (!element) throw new Error(`Missing element: ${selector}`);
    return element;
  }
}
